import { Column } from "components/common/Layout/Column";
import CreateDepositButton from "./CreateDepositButton";
import CreateDriverButton from "./CreateDriverButton";
import { Row } from "components/common/Layout/Row";
import { DeliveryDriversList } from "./DeliveryDriversList";

export default function DriversContainer() {
  return (
    <Column sx={{ width: "100%" }}>
      <Row justifyContent="space-around">
        <CreateDriverButton />
      </Row>
      <DeliveryDriversList />
    </Column>
  );
}
